import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { WaypointType } from '@treadinc/horizon-api-spec';
import dayjs from 'dayjs';
import { t } from 'i18next';

import useDispatchNumberLabel from '~hooks/useDispatchNumberLabel';
import { Job } from '~hooks/useJob/models';

interface JobSummaryPanelProps {
  job: Job;
}

function SummaryField({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {label}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        {value || '-'}
      </Typography>
    </Box>
  );
}

export default function JobSummaryPanel({ job }: JobSummaryPanelProps) {
  const { singular } = useDispatchNumberLabel();
  const pickupWaypoint = job.waypoints.find(
    (waypoint) => waypoint.type === WaypointType.PICKUP,
  );

  return (
    <Box data-test-id="ticket-drawer-job-summary">
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        {t('ticket_drawer_v2.job_summary.title')}
      </Typography>

      <Box sx={{ display: 'grid', gap: 2.5, gridTemplateColumns: '1fr 1fr' }}>
        <SummaryField
          label={t('ticket_drawer_v2.job_summary.customer')}
          value={job.order?.account?.name ?? ''}
        />
        <SummaryField
          label={t('ticket_drawer_v2.job_summary.project')}
          value={job.projectName}
        />
        <SummaryField
          label={singular('ticket_drawer_v2.job_summary.dispatch_number')}
          value={job.order?.dispatchNumber?.name ?? ''}
        />
        <SummaryField
          label={t('ticket_drawer_v2.job_summary.driver')}
          value={job.driverFullName}
        />
        <SummaryField
          label={t('ticket_drawer_v2.job_summary.service_date')}
          value={job.jobStartAt ? dayjs.tz(job.jobStartAt).format('MMM D, YYYY') : ''}
        />
        <SummaryField
          label={t('ticket_drawer_v2.job_summary.pickup_site')}
          value={pickupWaypoint?.site?.name ?? ''}
        />
      </Box>
    </Box>
  );
}
